import { getSrc } from 'gatsby-plugin-image'

/**
 * Tries to find the relative local path of an image object.
 *
 * @param {object} image Either a featured image or file object.
 * @returns the relative path of the image or null.
 */
export const getLocalImagePath = image => {
    if (!image) {
        return null
    }

    if (image.file) {
        image = image.file
    }

    if (image.node) {
        image = image.node.localFile
    }

    if (image.localFile) {
        image = image.localFile
    }

    if (image.childImageSharp) {
        return getSrc(image.childImageSharp)
    }

    if (image.publicURL) {
        return image.publicURL
    }

    return getSrc(image)
}
